import { useEffect, useRef } from 'react'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'

import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { SocketSender } from 'src/api/socket'

const useSocketPingPongHook = () => {
  const intervalRef = useRef<NodeJS.Timer | null>(null);
  const dispatch = useAppDispatch()

  const { Connection } = useAppSelector((state: RootState) => state.connection)
  const { socket_connected } = useAppSelector((state: RootState) => state.socket)

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      if (socket_connected) {
        dispatch(SocketSender(Cmdtypes.PING_PONG));
      }
    }, 180000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [dispatch, Connection, socket_connected])
}
export default useSocketPingPongHook
